import { FC, useRef, useEffect } from 'react'
import Image from 'next/image'

import Auth from 'store/auth'
import Button from '../../../../parts/button/button'
import PopupWrapper from 'containers/popup-wrapper/popup-wrapper'
import CheckupParameters from '../../CheckupParameters'

import { buttonIdArgeeCheckup } from 'constants/clickableElementsId'
import { STATIC_URL } from 'constants/data'

import styles from './watch-checkup.module.scss'

const staticFiles = {
  sound: `${STATIC_URL}/boop.mp3`,
  icon_success: `${STATIC_URL}/icons/icon_success.svg`,
  icon_warning: `${STATIC_URL}/icons/icon_warning_blue.svg`,
}

interface IYouTubeCheckup {
  checkup: {
    checkupId: number
    successCheckup: boolean
  }
  handleShowConfirm: () => void
}

const WatchCheckup: FC<IYouTubeCheckup> = ({ checkup, handleShowConfirm }: IYouTubeCheckup) => {
  const audioRef = useRef<HTMLAudioElement>(null)
  const checkupRef = useRef<HTMLDivElement>(null)
  const { isFilledUser, isSponsor } = Auth.useAuth()

  const isChecked = checkup?.successCheckup
  const isShow = (Boolean(checkup?.checkupId) || isChecked) && (isFilledUser || isSponsor)

  useEffect(() => {
    try {
      if (isShow && audioRef.current?.play) {
        audioRef.current.play().then(() => console.log('Звук есть'))
      }
    } catch (err) {
      console.log('Звук запрещен ', err)
    }
  }, [isShow])

  useEffect(() => {
    if (checkupRef.current && isShow) {
      const checkupData = checkupRef.current.getBoundingClientRect()
      CheckupParameters.set({ checkupData })
    }
  }, [isShow])

  return (
    <>
      <audio controls className={styles.audio} ref={audioRef} src={staticFiles.sound} />
      {isShow && (
        <PopupWrapper showBtnClose={false}>
          <h3>Контроль присутствия</h3>
          {isChecked ? (
            <div className={styles.container}>
              <Image
                src={staticFiles.icon_success}
                width="82"
                height="75"
                className={styles.icon}
                alt="success icon"
              />
              <p className={styles.text}>
                Ваше присутствие подтверждено.
                <br /> Спасибо, что вы с нами!
              </p>
            </div>
          ) : (
            <>
              <div className={styles.container} ref={checkupRef}>
                <Image
                  src={staticFiles.icon_warning}
                  width="75"
                  height="75"
                  className={styles.icon}
                  alt="warning icon"
                />
                <p className={styles.text}>Подтвердите, что вы просматриваете лекцию</p>
              </div>
              <div className={styles.btnWrapper}>
                <Button onClick={handleShowConfirm} id={buttonIdArgeeCheckup}>
                  Подтвердить
                </Button>
              </div>
            </>
          )}
        </PopupWrapper>
      )}
    </>
  )
}

export default WatchCheckup
